var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"body"},[_c('navbar'),(_vm.isloaded)?_c('div',[(_vm.info || _vm.isBblock == 0)?_c('Profile',{key:_vm.foll_id,staticClass:"wahala"}):_c('notFound'),_c('Footer')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }